import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import { DeviationResourceType } from '../../../types/deviation';
import { BiData } from '@wix/da-bi/pkg/events';
const DeleteTier = ({ deviation, stopPropagation, afterActionUrl, deleteTier })=>{
    var _deviation_tier_stats, _deviation_tier;
    const { t } = useTranslation();
    var _deviation_tier_stats_subscribers;
    return /*#__PURE__*/ React.createElement(ListItemButton, {
        label: t('common.delete'),
        onClick: ()=>deleteTier(afterActionUrl),
        stopPropagation: stopPropagation,
        biData: BiData({
            evid: 541,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId,
            has_subscribers: ((_deviation_tier_stats_subscribers = (_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : (_deviation_tier_stats = _deviation_tier.stats) === null || _deviation_tier_stats === void 0 ? void 0 : _deviation_tier_stats.subscribers) !== null && _deviation_tier_stats_subscribers !== void 0 ? _deviation_tier_stats_subscribers : 0) > 0 ? 1 : 0
        }),
        fillContainerWidth: true
    });
};
DeleteTier.displayName = 'DeleteTier';
export default DeleteTier;

//# sourceMappingURL=DeleteTier.js.map